import dayjs from "dayjs";
import "dayjs/locale/nl";
import utcPlugin from 'dayjs/plugin/utc';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import localizedFormatPlugin from 'dayjs/plugin/localizedFormat';
import customParseFormatPlugin from 'dayjs/plugin/customParseFormat';


export default function useDateTimeFormatter() {
  //console.log("dateTimeFormatter start ");
  // const utcPlugin = require("dayjs/plugin/utc");
  dayjs.extend(utcPlugin);

  dayjs.extend(isBetweenPlugin);

  dayjs.extend(localizedFormatPlugin);

  dayjs.extend(customParseFormatPlugin);
  
  dayjs.locale("nl");

  const utcToLocal = (date) => {
    return dayjs.utc(date).local();
  };

  //was formatDate
  const formatDateUtc = (date) => {
    if (date) {
      return utcToLocal(date).format("L");
    } else {
      return "-";
    }
  };

  //was formatDateS
  const formatDateUtcD = (date) => {
    if (date) {
      return utcToLocal(date).format("DD-MM-YYYY");
    } else {
      return "-";
    }
  };

  //was formatDateST
  const formatDateUtcDT = (date) => {
    if (date) {
      return utcToLocal(date).format("DD-MM-YYYY HH:mm:ss");
    } else {
      return "-";
    }
  };

  //was formatDateL
  const formatDateUtcL = (date) => {
    if (date) {
      return utcToLocal(date).format("dd D MMM YYYY h:mm:ss");
    } else {
      return "-";
    }
  };

  const toUtcFormat = (date) => {
    return dayjs(date).format("DD-MM-YYYY");
  };

  const formatMonth = (month) => {
    const date = dayjs().month(month - 1);
    return date.format("MMMM");
  };

  //was formatDateApi
  const formatDateApi = (value) => {
    if (value && value != "") {
      return dayjs(value).format("YYYYMMDD");
    } else {
      return undefined;
    }
  };

  //was getDateString
  const formatDateIsoD = (date) => {
    if (date) {
      return dayjs(date).format("YYYY-MM-DD");
    } else {
      return "";
    }
  };

  const formatDateUtcIsoD = (date) => {
    if (date) {
      return utcToLocal(date).format("YYYY-MM-DD");
    } else {
      return "";
    }
  };

  function formatDateCustom(date, format) {
    if (date) {
      return dayjs(date).format(format);
    } else {
      return "";
    }
  }

  //was parseStringDate
  const parseDateIso = (date) => {
    return dayjs(date, "YYYY-MM-DD");
  };

  // There is a bug in DateJS where values like 30-09-YYYY are not converted to YYYY-MM-DD, but result in 'Invalid date'.
  // This is a manual method to set the date with DateJS and also ensure the format is correct.
  const formatDateIso = (date) => {
    // Try to parse the date from Veutify. If the value is not changed this parsedDate will be invalid.
    var parsedDate = dayjs(date, "DD-MM-YYYY", false);
 
    // // Check if the parsed date is a Region NL date. If not the value will be USA date.
    if (!parsedDate.isValid()) {
      return parsedDate;
    }

    return result.format("YYYY-MM-DD");;
  };

  //was parseInputDate
  const parseDateInput = (date) => {
    return dayjs(date, "D-M-YYYY");
  };

  const dateBetween = (date, fromDate, tillDate) => {
    return dayjs(date).isBetween(fromDate, tillDate, "days", "[]"); // all inclusive
  };

  const vuetifyDateInputParser = (dateString) => {
    if (dateString === undefined) {
      return null;
    } else {
      console.log(dateString)
      const date = dayjs(dateString, "YYYY-MM-DD", false);
      console.log(date);
      return date.toDate();
    }
  };

  return {
    utcToLocal,
    formatDateUtc,
    formatDateUtcD,
    formatDateUtcDT,
    formatDateUtcL,
    formatDateApi,
    formatDateIsoD,
    formatDateUtcIsoD,
    formatDateCustom,
    toUtcFormat,
    formatMonth,
    parseDateIso,
    parseDateInput,
    dateBetween,
    vuetifyDateInputParser,
    formatDateIso,
  };
}
